import { SALES_LEAD_CAPTURE_PAGE } from "@/data/marketing/capabilityPages";
import SegmentLandingPage from "@/pages/Segments/SegmentLandingPage";

const SalesLeadCapturePage = () => {
  return <SegmentLandingPage content={SALES_LEAD_CAPTURE_PAGE} />;
};

export default SalesLeadCapturePage;
